<template>
  <div id="app">
    <router-view />
    <loginReg />
    <windowBox />
  </div>
</template>
<script>
import loginReg from "@/components/loginReg";
import windowBox from "@/components/window";
import jsonpAdapter from 'axios-jsonp';
import {
  RSAAPP,
  RSAKeyPair,
  encryptedString,
  decryptedString
} from '@/js/utils/RSA/rsa.js';
import {
    setMaxDigits
} from '@/js/utils/RSA/BigInt.js';
export default {
  name:'app',
  components:{loginReg,windowBox},
  data(){
    return {
      activeRouter:true
    }
  },
  methods:{
    async visiterLogin(){
      //游客登录
      var nowtimeStamp = new Date().getTime();
      
      let pid = this.$utils.getUrlKey("pid") ? this.$utils.getUrlKey("pid") : '167';
      let qid = this.$utils.getUrlKey("qid") ? this.$utils.getUrlKey("qid") : '61000';
      let sqid = this.$utils.getUrlKey("sqid") ? this.$utils.getUrlKey("sqid") : '0';
      let reg_mac = this.$utils.getUrlKey("mac") ? this.$utils.getUrlKey("mac") : this.$md5(nowtimeStamp + 'wechatminiprogram');
      var data = {
              reg_mac: reg_mac,
              version: '1.0.0',
              p_id: pid,
              qid: qid,
              timestamp: nowtimeStamp,
              sqid: sqid
          }
      var res=await this.axios({
        url:window.location.protocol+"//api.fengbolive.com/userinfo/visitors-login/login.html?"+this.$common.changeobj(data),
        adapter: jsonpAdapter
      })
      res=res.data;
      this.$store.dispatch('uiState_update_login_user_info',res.data);
      localStorage.setItem('mac',reg_mac);
      sessionStorage.setItem('userInfo',JSON.stringify(res.data.info));
      sessionStorage.setItem('token',res.data.token);
    },
    async getLoginLevel(uid, token){
      //let nowtimeStamp = new Date().getTime();
      //"user_id=%I64d&token=%s&reg_mac=%s&uid=%I64d";
      //let sign = this.getSign( this.userInfo.user_id, this.$store.state.loginUserInfo.version, nowtimeStamp, this.userToken, iPage, localStorage.getItem('mac'), 'get_hot_list_h5');
      var parData = {
        user_id:uid,
        token: token,
        reg_mac: localStorage.getItem('mac'),
        uid:uid,
      };
      let that = this;
      let res = await this.axios({
        url:"https://api.fengbolive.com/userinfo/getuserinfo/getlevle.html?" + this.$common.changeobj(parData)
      });
      let data = res.data;
      if (data.code >= 0 || data.ret >= 0) {
          this.$store.dispatch('upDateLoginUserLevel',data.data);
          sessionStorage.setItem('userLevel',JSON.stringify(data.data));
      }
    },
    async getExtraInfo(uid, token){
      let parData = {
        user_id:uid,
        token: token,
        reg_mac: localStorage.getItem('mac'),
        uid:uid,
      };
      let that = this;
      let res = await this.axios({
        url:"https://api.fengbolive.com/userinfo/getinfo.html?" + this.$common.changeobj(parData),
        adapter: jsonpAdapter,
        callbackParamName: 'callback', // optional, 'callback' by default
      });
      let data = res.data;
      if (data.code >= 0 || data.ret >= 0) {
          this.$store.dispatch('upDateUserExtraInfo',data.data);
          sessionStorage.setItem('userExtraInfo',JSON.stringify(data.data));
      }
    },
    openReport(){
      let nowtimeStamp = new Date().getTime();
      let pid = this.$utils.getUrlKey("pid") ? this.$utils.getUrlKey("pid") : '167';
      let qid = this.$utils.getUrlKey("qid") ? this.$utils.getUrlKey("qid") : '61000';
      let sqid = this.$utils.getUrlKey("sqid") ? this.$utils.getUrlKey("sqid") : '0';
      let mFormate = "qid=" + qid + "&sqid=" + sqid + "&ctype=2";
      setMaxDigits(256);
      let RSAKey = new RSAKeyPair("10001", "", "00B11790EB15A8091706948D3CD4B10604359C1DE8BEFB3862EBB1E15D2BEEADB3", 256);
      let mValue = encodeURIComponent(encodeURIComponent(window.btoa(encryptedString(RSAKey, mFormate, RSAAPP.NoPadding, RSAAPP.RawEncoding))));

      let parData = {
        equipment:(pid==167?'web':'pc'),
        m: mValue,
        mac_code: localStorage.getItem('mac'),
        pid:pid,
        pversion: this.getBro(),
        time:nowtimeStamp,
        type:'open',
        version:'1.0.0'
      };
      let that = this;
      let res = this.axios({
      });

      this.axios({
        url:"https://api.fengbolive.com/userinfo/stat/client.html?" + this.$common.changeobj(parData),
        adapter: jsonpAdapter,
        callbackParamName: 'callback', // optional, 'callback' by default
      }).then(res=>{
      })
    },
    getBro(){
      let is360 = false;
      let isIE = false;
      let isFirefox = false;
      let isChrome = false;
      let isEdge = false;
      let broName = 'Runing';
      let str = '';
      let strStart = 0;
      let strStop = 0;
      let arr = new Array();
      let temp = '';

      let userAgent = window.navigator.userAgent; //包含以下属性中所有或一部分的字符串：appCodeName,appName,appVersion,language,platform

      /*alert(userAgent);*/

      //FireFox
      if (userAgent.indexOf('Firefox') != -1) {
        isFireFox = true;
        /*broName = 'FireFox浏览器';*/
        strStart = userAgent.indexOf('Firefox');
        temp = userAgent.substring(strStart);
        broName = temp

      }

      //Edge
      else if (userAgent.indexOf('Edge') != -1) {
        isEdge = true;
        /*broName = 'Edge浏览器';*/
        strStart = userAgent.indexOf('Edge');
        temp = userAgent.substring(strStart);
        broName = temp
      }

      //IE浏览器
      else if (userAgent.indexOf('NET') != -1 && userAgent.indexOf("rv") != -1) {
        isIE = true;
        /*broName = 'IE浏览器'; */
        strStart = userAgent.indexOf('rv');
        strStop = userAgent.indexOf(')');
        temp = userAgent.substring(strStart, strStop);
        broName = temp.replace('rv', 'IE')
      }
      //Chrome浏览器
      else if (userAgent.indexOf('WOW') < 0 && userAgent.indexOf("Edge") < 0) {
        isChrome = true;
        /*broName = 'Chrome浏览器';*/
        strStart = userAgent.indexOf('Chrome');
        strStop = userAgent.indexOf(' Safari');
        temp = userAgent.substring(strStart, strStop);
        broName = temp;
      }
      //360极速模式可以区分360安全浏览器和360极速浏览器
      else if (userAgent.indexOf('WOW') != -1 && userAgent.indexOf("NET") < 0 && userAgent.indexOf("Firefox") < 0) {
        if(navigator.javaEnabled()) {
          is360 = true;
          broName = '360Safe/FastMode';
        } else {
          is360 = true;
          broName = '360Fast/FastMode';
        } 
      }
      //360兼容
      else if (userAgent.indexOf('WOW') != -1 && userAgent.indexOf("NET") != -1 && userAgent.indexOf("MSIE") != -1 && userAgent.indexOf("rv") < 0) {
        is360 = true;
        broName = '360/CompatibilityMode';
      }
      return broName;
    }
  },
  mounted(){
    if (!localStorage.getItem('client')) {
      let client = this.$utils.getUrlKey("fromclient");
      if (client && client=='pc') {
          localStorage.setItem('client','pc');
      }else{
          localStorage.setItem('client','web');
      }
    }
    // 渠道信息获取
    let pid = this.$utils.getUrlKey("pid") ? this.$utils.getUrlKey("pid") : '167';
    let qid = this.$utils.getUrlKey("qid") ? this.$utils.getUrlKey("qid") : '61000';
    let sqid = this.$utils.getUrlKey("sqid") ? this.$utils.getUrlKey("sqid") : '0';

    this.$store.commit('UPDATE_LOGIN_PID', pid);
    this.$store.commit('UPDATE_LOGIN_QID', qid);
    this.$store.commit('UPDATE_LOGIN_SQID', sqid);

    this.openReport();
  },
  created(){
    //是否是其他登录方式
    var Request =this.$common.GetRequest();
    if(Request['p']){
      try {
        var backJSON=JSON.parse(decodeURIComponent(Request['p']));
      } catch (error) {
        var backJSON=JSON.parse(Request['p']);
      }
      //var backJSON=JSON.parse(decodeURIComponent(Request['p']));
      if(backJSON.code==1){
        this.$common.setCookie('userInfo',JSON.stringify(backJSON.data),7);
        /*var now=new Date();
        var sbt=parseInt(now.getTime()/1000);
        var set=parseInt(now.setDate(now.getDate()+7)/1000);
        var logindata={
          'suid':backJSON.data.info.user_id,
          'snick':encodeURIComponent(backJSON.data.info.nick_nm),
          'sbt':sbt,
          'set':set
        };
        var md5data=this.$md5(sbt+''+set+logindata.suid+decodeURIComponent(logindata.snick)+'v0');*/
        //this.$common.cjcookie('FENGBOZHIBO',this.$common.changeobj(logindata),7,'/','.live.sinashow.com');
        //this.$common.cjcookie('FENGBO','es='+md5data+'&ev=v0',7,'/','.live.sinashow.com');
        /*this.$common.cjcookie('FENGBOZHIBO',this.$common.changeobj(logindata),7,'/','.fengbolive.com');
        this.$common.cjcookie('FENGBO','es='+md5data+'&ev=v0',7,'/','.fengbolive.com');*/
        if(location.href.indexOf('?p=')!=-1){
          location.href=location.href.substr(0,location.href.indexOf('?p='));
        }else{
          location.href=location.href.substr(0,location.href.indexOf('&p='));
        }
      }
    }else{
      //alert(location.href.substr(location.href.indexOf('?')));
      //是否记录登录
      if(this.$common.getCookie('userInfo')){
        var data=JSON.parse(this.$common.getCookie('userInfo'));
        this.getLoginLevel(data.info.user_id,data.token);
        this.getExtraInfo(data.info.user_id,data.token);        
        sessionStorage.setItem('userInfo',JSON.stringify(data.info));
        sessionStorage.setItem('token',data.token);
        this.$store.dispatch('uiState_update_login_user_info',data);
      }else{
        //游客登录
        this.visiterLogin();
      }
    }
  }
}
</script>